function PayPay() {
  return (
    <div className="payment-form fade">
      <h3>Pagamento PayPay</h3>

      <input placeholder="Número de Telefone" />

      <button className="pay-btn">Pagar com PayPay</button>
    </div>
  );
}

export default PayPay;
